export default {
	notification_health: 'Notification Health',
	notification_health_summary: 'Summary',
	notification_health_loading: 'Checking notification health...',
	notification_health_refresh: 'Refresh',
	notification_health_fix: 'What to do',
	notification_health_unavailable: 'Could not load notification health',
	notification_health_healthy: 'Healthy',
	notification_health_blocked: 'Blocked',
	notification_health_degraded: 'Needs attention',
	notification_health_no_app_user: 'No app login',
	notification_health_unknown: 'Unknown',
	notification_health_app_version: 'App version',
	notification_health_last_delivery: 'Last delivery',
	notification_health_time_just_now: 'just now',
	notification_health_time_minutes: '{count} minute(s) ago',
	notification_health_time_hours: '{count} hour(s) ago',
	notification_health_time_days: '{count} day(s) ago',
	notification_health_time_unknown: 'unknown',
	notification_health_summary_healthy: 'Notifications should work',
	notification_health_summary_no_app_user: 'Cleaner has not logged into the mobile app',
	notification_health_summary_blocked_no_token: 'Push token is missing — cleaner must open the app and log in',
	notification_health_summary_blocked_off: 'Notifications are turned off in the app',
	notification_health_check_portal_contact_label: 'Portal contact exists',
	notification_health_check_portal_active_label: 'Contact is active',
	notification_health_check_portal_rooms_label: 'Rooms assigned',
	notification_health_check_portal_shifts_label: 'Shifts assigned',
	notification_health_check_app_user_label: 'Logged into mobile app',
	notification_health_check_push_token_label: 'Push token registered',
	notification_health_check_notification_mode_label: 'Notification mode',
	notification_health_check_time_schedule_label: 'Within notification time window',
	notification_health_check_ios_geo_filter_label: 'iOS location filter',
	notification_health_check_recent_push_attempt_label: 'Recent push attempted (48h)',
	notification_health_check_last_push_ignored_label: 'Latest signal was not sent',
	notification_health_check_recent_push_delivered_label: 'Recent push delivered (48h)',
	notification_health_detail_portal_contact_found: 'Found in portal',
	notification_health_detail_portal_contact_missing: 'No contact record found',
	notification_health_detail_portal_active_active: 'Active',
	notification_health_detail_portal_active_inactive: 'Inactive',
	notification_health_detail_portal_rooms_assigned: '{count} room(s)',
	notification_health_detail_portal_rooms_none: 'No rooms assigned',
	notification_health_detail_portal_shifts_assigned: '{count} shift(s)',
	notification_health_detail_portal_shifts_none: 'No shifts assigned',
	notification_health_detail_app_user_logged_in: 'App version {version}, last sync {lastSync}',
	notification_health_detail_app_user_never: 'Never logged in',
	notification_health_detail_push_token_present: 'FCM token present',
	notification_health_detail_push_token_empty: 'Token is empty',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Current time is inside schedule',
	notification_health_detail_time_schedule_outside: 'Current time is outside configured schedule',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'No push attempts in last 48 hours',
	notification_health_detail_last_push_ignored: 'Last push request was ignored (servik not configured for working area)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'No successful deliveries in last 48 hours',
	notification_health_fix_portal_contact: 'Create this cleaner in the Users panel',
	notification_health_fix_portal_active: 'Enable the Active toggle for this cleaner',
	notification_health_fix_portal_rooms: 'Assign at least one room to this cleaner',
	notification_health_fix_portal_shifts: 'Assign at least one shift',
	notification_health_fix_app_user: 'Cleaner must install the app and log in with this phone number',
	notification_health_fix_push_token: 'Ask cleaner to open the app, allow notifications in iOS Settings, and log in again',
	notification_health_fix_notification_mode: 'Change notification mode from Off to Always in the app',
	notification_health_fix_time_schedule: 'Wait until the scheduled window or change mode to Always',
	notification_health_fix_ios_geo_filter: 'Cleaner is outside their notification zone — have them open the app on site',
	notification_health_fix_last_push_ignored: 'Check working area servik configuration for the room that triggered the signal',
	notification_health_fix_recent_push_delivered_filters: 'Check notification filters or device settings',
	notification_health_fix_recent_push_delivered_token: 'Register push token first',
	notification_health_mode_on: 'Always',
	notification_health_mode_off: 'Off',
	notification_health_mode_time: 'Time based',
	notification_health_mode_location: 'Location based',
	notification_health_filter_on: 'On',
	notification_health_filter_off: 'Off',
};
